import { useEffect } from 'react';
import HeaderOnlyWhite from '../components/HeaderOnlyWhite'
import FooterNoTop from '../components/FooterNoTop.jsx';

import '../Assets/css/hoteldetails.css'
import '../Assets/css/extrapagefunc.css'

import  '../Assets/js/extrapagefunc.js'

function NotFound()
{
    // Append CSS -----------------------------------------------------
    useEffect(() =>
    {
      window.CallDefaultFunction("NotFound");
    }, []);

    // Append Body Element To 'root' -----------------------------------------------------
    return(
      <>
        <div className="basic">

          <HeaderOnlyWhite/>

          <div className="MainContentSection">
            <div className='PageNotFoundTextMainContainer'>
                <div className='PageNotFoundTextWrapper'>
                    <img src="/Assets/images/Icon/page-not-found-icon.svg" className='PageNotFoundIcon'/>
                    <p className="SectionHeaderTextIndex InterMediumTextFont" style={{color:"#000000"}} id='NotFoundPageHeader'>Halaman Tidak Ditemukan</p>
                    <p className="LabelGreyHeaderSmallerText2 InterMediumTextFont" style={{color:"#000000"}} id='NotFoundPageMessageText'>Link yang kamu tuju mungkin sudah pindah atau dihapus. Yuk, lanjut explore penginapan unik lainnya.</p>
                    <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable">
                        <p id='ExplorePinginGoNotFoundText'>Explore PinginGo</p>
                        <a href="/search/en/bali.html?search=Bali" className="HREFInsideContainer"></a>
                    </button>
                </div>
                <img src="/Assets/images/not-found-bottom.png" className="BottomNotFoundImage"/>
            </div>

          </div>

        </div>

        <FooterNoTop/>
        
      </>
    )
}

export default NotFound